import { __rest } from 'tslib';
import React from 'react';
import { Root } from './styled.js';

const Tooltip = React.forwardRef((_a, ref) => {
    var { lineBreak, mouseEnterDelay = 0.5 } = _a, props = __rest(_a, ["lineBreak", "mouseEnterDelay"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-tooltip' }, props, { ref: ref, "$lineBreak": lineBreak, mouseEnterDelay: mouseEnterDelay })));
});
Tooltip.displayName = 'Tooltip';

export { Tooltip };
